import React , {useState} from 'react'
import { Col, Modal, ModalBody, Label, ModalHeader, Row} from "reactstrap";
import {  AvForm } from "availity-reactstrap-validation";
import {  useDispatch } from "react-redux";

import { casosUpdate } from '../../../../store/casos/actions';


const ModalObservaciones = (props) => {
  const dispatch = useDispatch();
    console.log(props)
    const handleButtonClick = () => {
        props.onCloseClick(); // Llama a la función onCloseClick pasada como prop desde el componente padre
      };

      const [formData, setFormData] = useState({
      
        observacionesGestiones: "",
    
      });
    
      const {  observacionesGestiones } =
        formData;

        const onChange = (e) => {
            const uppercaseValue = e.target.value.toUpperCase();
            setFormData({ ...formData, [e.target.name]: uppercaseValue });
          };
    
        const onSubmit = (e) => {
            e.preventDefault();
        

            dispatch(casosUpdate(`${props.Item.id}`, {
              estatus: 'PAUSAR',
              observacionesGestiones
            }));
        
            // console.log(data)
        
  
          };
    return ( 
        <React.Fragment>
<Modal isOpen={props.verModal} toggle={props.onCloseClick} centered={true} >
        <ModalHeader toggle={handleButtonClick} tag="h4">
          Coloque la observacion para pausar el caso
        </ModalHeader>
     

        <ModalBody>

        <AvForm onSubmit={onSubmit}>

        <Col>
                <Label
                  for="observaciones"
                  className="col-form-label col-sm-4 d-flex"
                >
                  OBSERVACIONES
                </Label>

                <textarea
                  className="form-control"
                  id="observacionesGestiones"
                  name="observacionesGestiones"
                  type="textarea"
                  rows="4"
                  onChange={onChange}
                  value={observacionesGestiones}
                />
              </Col>

                {/* Botones de abajo */}
            <Row>
              <Col>
                <div className="text-end">
                  <button
                    type="button"
                    className="btn btn-light me-2"
                    onClick={handleButtonClick}
                  >
                    CERRAR
                  </button>
                
                  <button type="submit" className="btn btn-success save-event">
                    GUARDAR
                  </button>
                </div>
              </Col>
            </Row>
        </AvForm>
        </ModalBody>
        </Modal>

        </React.Fragment>
     );
}
 
export default ModalObservaciones;